module.exports = __webpack_public_path__ + "img/youtube.2d8c2fd6.png";